<template>
	<v-dialog
		:value="true"
		:fullscreen="$vuetify.breakpoint.mobile"
		max-width="480"
		content-class="assoc-panel-dialog"
		@input="$emit('close')"
		@click:outside="$emit('close')"
		@keydown.esc="$emit('close')"
	>
		<div class="assoc-panel">
			<div class="assoc-panel__header">
				<div class="assoc-panel__title">
					<v-icon size="18" color="#2D4B95" class="mr-2">mdi-link-variant</v-icon>
					<span>Todas las asociaciones</span>
				</div>
				<button class="icon-action-btn" @click="$emit('close')">
					<v-icon size="16" color="#576080">mdi-close</v-icon>
				</button>
			</div>

			<div class="assoc-panel__body">
				<div v-if="fileAssociations.length > 0" class="assoc-panel__section">
					<span class="assoc-panel__section-title">Archivos</span>
					<div class="assoc-panel__files">
						<AssociationFileCard
							v-for="association in fileAssociations"
							:key="`file-${association.association_id}`"
							:association="association"
							@click="$emit('open-file', association)"
							@remove="$emit('remove', association)"
						/>
					</div>
				</div>

				<div v-if="textAssociations.length > 0" class="assoc-panel__section">
					<span class="assoc-panel__section-title">RDIs, tareas y adicionales</span>
					<div class="assoc-panel__pills">
						<AssociationPill
							v-for="association in textAssociations"
							:key="`text-${association.association_id}`"
							:association="association"
							@click="$emit('open-text', association)"
							@remove="$emit('remove', association)"
						/>
					</div>
				</div>

				<div v-if="textAssociations.length === 0 && fileAssociations.length === 0" class="assoc-panel__empty">
					<v-icon size="30" color="#c2cbe0">mdi-link-off</v-icon>
					<span>No hay asociaciones</span>
				</div>
			</div>
		</div>
	</v-dialog>
</template>

<script>
import AssociationPill from '@/components/Globals/Helpers/ItemsAssociations/AssociationPill'
import AssociationFileCard from '@/components/Globals/Helpers/ItemsAssociations/AssociationFileCard'

export default {
	name: 'AssociationsPanel',
	components: { AssociationPill, AssociationFileCard },
	props: {
		textAssociations: {
			type: Array,
			default: () => []
		},
		fileAssociations: {
			type: Array,
			default: () => []
		}
	}
}
</script>

<style scoped>
.assoc-panel {
	background: #ffffff;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	max-height: 78vh;
}

.assoc-panel__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 14px 16px;
	border-bottom: 1px solid rgba(45, 75, 149, 0.09);
}

.assoc-panel__title {
	display: flex;
	align-items: center;
	font-size: 14px;
	font-weight: 700;
	color: #2d3a5c;
}

.icon-action-btn {
	width: 28px; height: 28px; border-radius: 7px;
	background: #EEF2FF; border: none; cursor: pointer;
	display: inline-flex; align-items: center; justify-content: center;
	transition: background 0.12s;
}
.icon-action-btn:hover { background: #dde5f9; }

.assoc-panel__body {
	overflow-y: auto;
	padding: 16px;
	display: flex;
	flex-direction: column;
	gap: 18px;
}

.assoc-panel__section-title {
	display: block;
	font-size: 11px;
	font-weight: 700;
	color: #99a5be;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	margin-bottom: 10px;
}

.assoc-panel__files {
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
}

.assoc-panel__pills {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}

.assoc-panel__empty {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	padding: 40px 0;
	color: #99a5be;
	font-size: 12.5px;
}
</style>